import BaseAPI from "./BaseAPI";

const validate = async (refNo) => {
    const url = `/xendit/validate`;
    const params = {
        refNo,
    };
    try {
        const res = await BaseAPI.post(url, params);
        if (res) return res;
        return null;
    } catch (err) {
        console.log(err);
    }
}

const redirect = async (params) => {
    try {
        const url = `/xendit/redirect`;
        const res = await BaseAPI.post(url, params);
        if (res) return res;
    } catch (err) {
        console.log(err)
    }
}

export default {
    validate,
    redirect
}